import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Alert from 'react-bootstrap/Alert';
import { withAuthorization } from '../Session';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import RestServices from '../services/RestServices.js';

const colorsArray =[
    { key: 'Red', value: '#f0806d' },
    { key: 'Green', value: '#79a72d' }
]

class index extends React.Component {
    _isMounted = false;
    state = {
        status: '',
        text_color:'#79a72d',
        showLoading:true,
        alert:0,
        alertMessage:'',
        
    };

    componentWillUnmount() {
        this._isMounted = false;
        
    }
    async componentDidMount() {
        this.GetStatus()
        this._isMounted = true;
    }
    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

        async GetStatus() {
        this.setState({ alert: 0, alertMessage: '',showLoading:true });
        RestServices.GlobalGet(
                localStorage.getItem('FirebaseToken'),
                'configuration/GetSiteStatus'
            )
                .then((response) => response.json())
                .then((responseData) => {
                    
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                alert: 1,
                                showLoading:false,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                            if (this._isMounted) {
                                this.setState({
                                    showLoading:false,
                                    status: responseData.status?responseData.status:'',
                                    text_color:responseData.text_color?responseData.text_color:''
                                });
                            }
                        
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            showLoading:false,
                            alertMessage: err.message
                        });
                    }
                });
        
    };

    UpdateStatus = () => {
            let data = {
                status: this.state.status,
                text_color:this.state.text_color,
                LastUpdatedTimeStamp: dateFormatUtil(),
                UpdatedBy: this.props.user.FullName
            ? this.props.user.FullName
            : 'Admin'
            };
            this.setState({ alert: 0, alertMessage: '',showLoading:true });
            RestServices.GlobalPost(
                    localStorage.getItem('FirebaseToken'),
                    data,
                    'configuration/UpdateSiteStatus'
                )
                    .then((response) => response.json())
                    .then((responseData) => {
                        if (responseData.error) {
                            if (this._isMounted) {
                                this.setState({
                                    alert: 1,
                                    showLoading:false,
                                    alertMessage: responseData.error
                                });
                            }
                        } else {
                                if (this._isMounted) {
                                    this.setState({
                                        alert: 2,
                                        showLoading:false,
                                        alertMessage:
                                            'Site Status updated...'
                                    });
                                }
                            
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState({
                                alert: 1,
                                showLoading:false,
                                alertMessage: err.message
                            });
                        }
                    });
            
        };

    render() {
        return (
            <Container className="no_padding">

                <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Manage Site Status
                            </h4>
                            
                        </Row>
                        <div>
                            <hr />
                        </div>
                    {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}
                         
                {this.state.showLoading && <Spinner animation="border" />}

                    <Row>

                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Site Status</Form.Label>
                                <Form.Control
                                    placeholder="Enter status"
                                    type="text"
                                    name="status"
                                    value={this.state.status}
                                    onChange={this.onChangeValues}
                                    required
                                />
                            </Form.Group>
                        </Form.Row> 
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Text Color</Form.Label>
                                <select
                                        className="form-control"
                                        style={{ width: '200px' }}
                                        name="text_color"
                                        onChange={this.onChangeValues}
                                        value={this.state.text_color}
                                    >
                                        {colorsArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    
                                    
                            </Form.Group>
                        </Form.Row> 

                        </Row>
                        <Row>
                        <Form.Row>
                            <Button
                                variant="primary"
                                type="submit"
                                onClick={this.UpdateStatus}
                            >
                                Update
                            </Button>
                        </Form.Row>
                        </Row>
            </Container>
        );
    }
}


const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(index);
